import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d11ecd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "booking-section" }
const _hoisted_2 = { class: "card-header booking-section-header" }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = {
  key: 0,
  class: "col-md-1"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Search For Existing Booking")
], -1))
const _hoisted_6 = { class: "col-md-5" }
const _hoisted_7 = { class: "col-4 text-right" }
const _hoisted_8 = {
  key: 0,
  class: "pr-1"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "chip-head" }
const _hoisted_11 = ["title"]
const _hoisted_12 = { class: "chip-content" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-parking" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 0,
  class: "row mt-4"
}
const _hoisted_17 = { class: "col-md-12" }
const _hoisted_18 = { style: {"white-space":"pre-wrap"} }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fab fa-google" }, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { style: {"white-space":"pre-wrap"} }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }

import { computed, onMounted, ref, inject, nextTick, onBeforeUnmount, onUnmounted} from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import moment from "moment-timezone";
import { debounce } from "lodash";
import SearchByString from "@/components/diary/SearchByString.vue";
import BookingDetailModal from "@/components/modals/BookingDetailModal.vue";
import AlertDialog from "@/components/modals/AlertDialog.vue";
import { DxDataGrid, DxColumn, DxPaging } from "devextreme-vue/data-grid";
import { Booking } from "@/models";
import Ably from "ably";


export default /*#__PURE__*/_defineComponent({
  __name: 'Search',
  emits: ["showsearchresult", "hidesearchresult"],
  setup(__props, { emit: __emit }) {

const route = useRoute();
const router = useRouter();
const store = useStore();

const realtime: Ably.Realtime = inject("realtime");
const actProperty: any = inject("actProperty"); // Injected property
const channel = realtime.channels.get("diary");
const deviceid = actProperty.getDeviceId();

const searchresultgrid = ref(null);

const dictionary = computed(() => store.getters["dictionary/current"]);
const booking = computed((): Booking => store.getters["diary/booking"]);
const searchBookings = async (params: any) => {
  return await store.dispatch("diary/searchBookings", params);
};
const setBooking = (booking: any) => {
  store.commit('diary/setBooking', booking);
};
const email = computed(() => store.getters["auth/email"]);
const unlockBooking = async (booking: Booking) => {
  if (booking && booking.id) {
    await store.dispatch("diary/unlockBooking", booking).then((b: Booking) => {
      channel.publish("bookingunlocked", { bookingid: b.id });
    });
  }
};
const lockBooking = async (booking: Booking) => {
  if (booking && booking.id) {
    await store.dispatch("diary/lockBooking", booking).then((b: Booking) => {
      channel.publish("bookinglocked", { bookingid: b.id });
    });
  }
};
const parkedbookings = computed(() => store.getters["diary/parkedbookings"]);
const hasUnsavedChanges = computed(
  () => store.getters["diary/hasUnsavedChanges"]
);
const setCurrentdate = (currentdate: Date) => {  
  store.commit('diary/setCurrentdate', currentdate);
};
const parkBooking = () => {
  if (booking.value.id) {
    unlockBooking(booking.value);
    channel.publish("unselectBooking", { deviceid: deviceid });
  }
  store.commit("diary/parkBooking");

  nextTick(() => {
    store.commit("diary/resetUnsavedChanges");
    router.replace({ name: "newbooking", params: { id: booking.value.id } });
    //setCurrentdate(moment("2050-12-31", "YYYY-MM-DD").utc().toDate());
    setCurrentdate(moment().utc().toDate());
  });
};
const loadParkedBooking = (index:number,booking: Booking) => {
  if (
    !booking.locked ||
    (booking.locked && booking.lockedby === email.value)
  ) {
    if (hasUnsavedChanges.value) {
      const modal = alertDialog1.value as any;
      modal.init(
        "Warning",
        "There are unsaved changes. Please first save all the changes to load the selected booking.",
        "OK"
      );
      modal.show();
    } else {
      store.commit("diary/loadParkedBooking",index);
      nextTick(() => {
        store.commit("diary/addUnsavedChange", "parkedBooking");
        if (!booking.id) {
          router.replace({
            name: "newbooking",
            params: { id: booking.id },
            query: { parkedbookingid: 'new' },
          });
        } else {
          if (booking.id) {
            lockBooking(booking);
            channel.publish("unselectBooking", { deviceid: deviceid });
          }
          router.replace({
            name: "existingbooking",
            params: { id: booking.id },
            query: { parkedbookingid: booking.id },
          });
          setCurrentdate(booking.startdateAsDate);
        }
      });
    }
  }
};

const height = ref(window.innerHeight - window.innerHeight * 0.25);
const results = ref<Booking[]>([]);
const focusedRowKey = ref("");
const showserachresulttable = ref(false);
const todaymoment = ref(moment.utc(new Date()).startOf("day"));
const nowmoment = ref(moment());
const selectedbooking = ref(new Booking());

const emit = __emit;

const bookingDetailModal = ref(null);
const alertDialog1 = ref(null);

onMounted(() => {
  channel.subscribe("appointmentSearchRowSelected", (message: any) => {
    if (showserachresulttable.value && message?.data) {
      if (message.data.deviceid != deviceid) return;
      if (message.data.bookingid && results.value.length) {
        const index = results.value.findIndex(
          (b: Booking) => b.id === message.data.bookingid
        );
        if (index >= 0) {
          selectedbooking.value = results.value[index];
        }
      }
    }
  });
  channel.subscribe("appointmentSelected", (message: any) => {
    if (message?.data) {
      if (message.data.deviceid != deviceid) return;
      if(showserachresulttable.value){
        showserachresulttable.value = false;
        results.value = [];
        hideserachresult();
      }
    }
  });

  channel.subscribe('bookinglocked', (message: any) => {
    if (message?.data?.bookingid) {   
      // Make sure the event is coming from the same pc
      if (message?.data && message.data?.bookingid && parkedbookings.value.length > 0){
        const index = parkedbookings.value.findIndex(
          (n:Booking) => n.id === message.data?.bookingid
        );
        if (index >= 0) {
          let newlist = [...parkedbookings.value];
          newlist[index].locked = true;
          newlist[index].lockedby = message.data.lockedby;
          store.commit("diary/setParkBookings", newlist);
        }     
      }
    }
  });
  channel.subscribe('bookingunlocked', (message: any) => {
    if (message?.data?.bookingid) {
     // Make sure the event is coming from the same pc
     if (message?.data && message.data?.bookingid && parkedbookings.value.length > 0){
        const index = parkedbookings.value.findIndex(
          (n:Booking) => n.id === message.data?.bookingid
        );
        if (index >= 0) {
          let newlist = [...parkedbookings.value];
          newlist[index].locked = false;
          newlist[index].lockedby = message.data.lockedby;
          store.commit("diary/setParkBookings", newlist);
        }     
      }
    }
  });
});

onBeforeUnmount(() => {
  channel.unsubscribe("appointmentSearchRowSelected");
  channel.unsubscribe("appointmentSelected");
  channel.unsubscribe("bookinglocked");
  channel.unsubscribe("bookingunlocked");
});

const search = (val: string) => {
  searchBookings({ anytext: val, cancelled: "all", sort: "created_at", limit: 100 }).then(
    (bookings: Booking[]) => {
      processSearchResult(bookings);
    }
  );
};

const processSearchResult = (bookings: Booking[]) => {
  results.value = [];
  bookings.sort((b1: Booking, b2: Booking) => {
    if (moment.utc(b1.startdate).isAfter(moment.utc(b2.startdate))) {
      return 1;
    } else if (moment.utc(b1.startdate).isBefore(moment.utc(b2.startdate))) {
      return -1;
    } else {
      return 0;
    }
  });
  var futurebooking: Booking | undefined = bookings.find((b: Booking) =>
    moment.utc(b.startdate).isAfter(todaymoment.value as moment.Moment)
  );
  if (!futurebooking || !futurebooking?.id) {
    // If there is not future booking, select the last one in the list
    futurebooking =
      bookings.length > 0 ? bookings[bookings.length - 1] : undefined;
  }
  nowmoment.value = moment();
  results.value.push(...bookings);
  showserachresult();
  nextTick(() => {
    if (futurebooking?.id) {
      focusedRowKey.value = futurebooking?.id;
      searchresultgrid.value.instance.navigateToRow(futurebooking?.id);
      setTimeout(() => {
        const scrollOffset = searchresultgrid.value.instance
          .getScrollable()
          .scrollOffset();
        searchresultgrid.value.instance
          .getScrollable()
          .scrollTo(scrollOffset.top);
      }, 1000);
    }
  });
};

const showserachresult = () => {
  showserachresulttable.value = true;
  emit("showsearchresult");
};
const hideserachresult = () => {
  showserachresulttable.value = false;
  emit("hidesearchresult");
};

const onSearchTableRowPrepared = (e: any) => {
  if (e.rowType === "data") {
    if (e.data.cancelled) {
      e.rowElement.classList.add("cancelled-booking");
    }
    if (
      e.data.startdate &&
      moment.utc(e.data.startdate).isBefore(nowmoment.value as moment.Moment)
    ) {
      e.rowElement.classList.add("historical-booking");
    }
  }
};

const onSearchTableCellPrepared = (e: any) => {
  if (e.rowType === "data") {
    if (e.data.cancelled) {
      e.cellElement.classList.add("transparent-background");
    }
  }
};

const dbonAppointmentClick = debounce((e: any) => {
  if (e.data) {
    let booking: Booking = e.data;
    if (booking.subtype != Booking.PERSONAL) {
      const modal = bookingDetailModal.value as any;
      if (modal) {
        modal.init(booking);
        modal.show();
      }
    }
  }
}, 250);

const onAppointmentClick = (e: any) => {
  e.cancel = true;
  dbonAppointmentClick(e);
};

const onAppointmentDblClick = (e: any) => {
  e.cancel = true;
  dbonAppointmentClick.cancel();
  if (e.data) {
    let booking: Booking = e.data;
    if (booking.googleid) {
      selectBooking(booking);
    }
    // eslint-disable-next-line no-empty
    else if (booking.jobtype === Booking.PERSONAL) {
    } else if (!booking.subtype) {
      selectBooking(booking);
      channel.publish("appointmentSearchRowSelected", {
        deviceid: deviceid,
        bookingid: booking.id,
      });
      hideserachresult();
    }
  }
};

const selectBooking = (booking: Booking) => {
  if (booking.googleid || !booking.jobtype) {
    locatebooking(booking);
    selectedbooking.value = booking;
  } else if (booking.subtype) {
    locatebooking(booking);
    selectedbooking.value = booking;
  } else {
    locatebooking(booking);
    channel.publish("appointmentSelectedInSearch", {
      deviceid: deviceid,
      bookingid: booking.id,
      inspectorid: booking.inspector?.id,
    });
    selectedbooking.value = booking;
  }
};

const locatebooking = (booking: Booking) => {
  channel.publish("locateBooking", {
    deviceid: deviceid,
    bookingid: booking.id,
    date: booking.startdate,
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (showserachresulttable.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("i", {
                class: "col-auto fas fa-arrow-left fa-2x",
                onClick: hideserachresult
              })
            ]))
          : _createCommentVNode("", true),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(SearchByString, {
            placeholder: "Search",
            onSearchsubmit: search,
            showserachresulttable: showserachresulttable.value
          }, null, 8, ["showserachresulttable"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (parkedbookings.value.length)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Parked "))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parkedbookings.value, (parkedbooking, $index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "chip",
              style: {"cursor":"pointer"},
              key: parkedbooking.id,
              onClick: ($event: any) => (loadParkedBooking($index,parkedbooking))
            }, [
              _createElementVNode("div", _hoisted_10, _toDisplayString($index + 1), 1),
              (parkedbooking.locked)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: "fas fa-lock icon-botton-left",
                    style: {"color":"yellow"},
                    title: parkedbooking.lockedby
                  }, null, 8, _hoisted_11))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_12, _toDisplayString(parkedbooking.address.postcode), 1)
            ], 8, _hoisted_9))
          }), 128)),
          _createElementVNode("button", {
            disabled: 
              !booking.value.address ||
              !booking.value.address.postcode ||
              parkedbookings.value.length === 3
            ,
            type: "button",
            class: "btn btn-outline-light ml-2",
            "aria-label": "Park booking",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (parkBooking()))
          }, _hoisted_15, 8, _hoisted_13)
        ])
      ])
    ]),
    (showserachresulttable.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_unref(DxDataGrid), {
              ref_key: "searchresultgrid",
              ref: searchresultgrid,
              height: height.value,
              "data-source": results.value,
              "key-expr": "id",
              "allow-column-reordering": false,
              "allow-column-resizing": false,
              "column-auto-width": true,
              "show-borders": false,
              "show-column-lines": false,
              "show-row-lines": true,
              "row-alternation-enabled": true,
              "focused-row-enabled": true,
              "auto-navigate-to-focused-row": true,
              "focused-row-key": focusedRowKey.value,
              "no-data-text": "No bookings found for given search",
              onRowClick: onAppointmentClick,
              onRowDblClick: onAppointmentDblClick,
              onRowPrepared: onSearchTableRowPrepared,
              onCellPrepared: onSearchTableCellPrepared
            }, {
              timeCellTemplate: _withCtx(({ data }) => [
                _createElementVNode("span", _hoisted_18, _toDisplayString(data.data.starttime) + " to " + _toDisplayString(data.data.endtime), 1)
              ]),
              apptimeCellTemplate: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(data.data.appointmenttimeForDisplay === "Invalid date"
                ? ""
                : data.data.appointmenttimeForDisplay), 1)
              ]),
              jobtypeCellTemplate: _withCtx(({ data }) => [
                (!data.data.googleid)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_unref(actProperty).getBookingTitle(data.data, dictionary.value)), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
              ]),
              addressCellTemplate: _withCtx(({ data }) => [
                _createElementVNode("span", _hoisted_23, [
                  (data.data.googleid)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                        _createElementVNode("div", null, _toDisplayString(data.data.location), 1),
                        _createElementVNode("div", null, _toDisplayString(data.data.summary), 1)
                      ]))
                    : (data.data.jobtype === 'Personal')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(data.data.summary), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(data.data.addressPreview), 1))
                ])
              ]),
              companyNameCellTemplate: _withCtx(({ data }) => [
                (data.data.subtype && data.data.leadbooking)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(data.data.leadbooking.customer.companyName), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(data.data.customer.companyName), 1))
              ]),
              branchNameCellTemplate: _withCtx(({ data }) => [
                (data.data.subtype && data.data.leadbooking)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(data.data.leadbooking.customer.branchName), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(data.data.customer.branchName), 1))
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(DxColumn), {
                  width: "15%",
                  fixed: true,
                  "data-field": "bookingdatewithday",
                  caption: "Date"
                }),
                _createVNode(_unref(DxColumn), {
                  width: "15%",
                  fixed: true,
                  "cell-template": "timeCellTemplate",
                  caption: "Time"
                }),
                _createVNode(_unref(DxColumn), {
                  width: "10%",
                  fixed: true,
                  "cell-template": "apptimeCellTemplate",
                  caption: "Appointment Time"
                }),
                _createVNode(_unref(DxColumn), {
                  width: "5%",
                  fixed: true,
                  "cell-template": "jobtypeCellTemplate",
                  caption: "Job Type"
                }),
                _createVNode(_unref(DxColumn), {
                  width: "25%",
                  fixed: true,
                  "cell-template": "addressCellTemplate",
                  caption: "Address/Summary"
                }),
                _createVNode(_unref(DxColumn), {
                  width: "10%",
                  fixed: true,
                  "data-field": "inspector.name",
                  caption: "Inspector"
                }),
                _createVNode(_unref(DxColumn), {
                  width: "10%",
                  fixed: true,
                  "cell-template": "companyNameCellTemplate",
                  caption: "Customer"
                }),
                _createVNode(_unref(DxColumn), {
                  width: "10%",
                  fixed: true,
                  "cell-template": "branchNameCellTemplate",
                  caption: "Branch"
                }),
                _createVNode(_unref(DxPaging), { enabled: false })
              ]),
              _: 1
            }, 8, ["height", "data-source", "focused-row-key"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(BookingDetailModal, {
      id: "search-booking-detail-model",
      ref_key: "bookingDetailModal",
      ref: bookingDetailModal,
      editable: false
    }, null, 512),
    _createVNode(AlertDialog, {
      ref_key: "alertDialog1",
      ref: alertDialog1,
      name: "alertdialog1"
    }, null, 512)
  ]))
}
}

})